import { render } from "./ProfitLoss.vue?vue&type=template&id=7b458204&scoped=true&ts=true"
import script from "./ProfitLoss.vue?vue&type=script&lang=ts"
export * from "./ProfitLoss.vue?vue&type=script&lang=ts"

import "./ProfitLoss.vue?vue&type=style&index=0&id=7b458204&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b458204"]])

export default __exports__